// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-item_3f614340 {
  position: relative;
  flex-shrink: 0;
  opacity: 1;
}
.carousel-item__child_3f614340 {
  width: 100%;
}
.carousel-item-enter_3f614340 {
  opacity: 0;
}
.carousel-item-enter-active_3f614340 {
  opacity: 1;
  transition: all 500ms ease-out;
}
.carousel-item-exit_3f614340 {
  opacity: 1;
}
.carousel-item-exit-active_3f614340 {
  opacity: 0;
  transition: all 500ms ease-out;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carousel-item": `carousel-item_3f614340`,
	"carousel-item__child": `carousel-item__child_3f614340`,
	"carousel-item-enter": `carousel-item-enter_3f614340`,
	"carousel-item-enter-active": `carousel-item-enter-active_3f614340`,
	"carousel-item-exit": `carousel-item-exit_3f614340`,
	"carousel-item-exit-active": `carousel-item-exit-active_3f614340`
};
export default ___CSS_LOADER_EXPORT___;
